export default class spGnavi {
    constructor(){

        this.status = {
            open :false
        }

        this.$trigger;
        this.$container
        this.$bg

        this.$link

    }
    init(scroll,pageID){

        this.$container = document.querySelector(".header-inner-sp .header-nav")
        this.$bg = document.querySelector(".header-inner-sp .header-overlay")
        this.$trigger = document.querySelector(".header-inner-sp .nav-btn")
        this.$link = document.querySelectorAll(".header-inner-sp .header-nav-link .js_spnavi-link")

        this.$trigger.addEventListener("click",(e)=>{

            if(!this.status.open){
                this.show()
            }else{
                this.out()
            }

        })

        for(let i in this.$link) {
            if (this.$link[i].nodeType != 1) continue; // dom要素以外は処理止める

            this.$link[i].addEventListener("click",(e)=>{

                if(pageID!="top") return

                this.out();
                scroll.selectTo(e.target.getAttribute("data-target"))

            })

        }
    }
    show(){
        this.status.open = true

        this.$container.classList.add("is-open")
        this.$trigger.children[0].classList.add("is-open")

        TweenMax.to(this.$container,0.4,{
            opacity : 1,
        })
        TweenMax.to(this.$bg,0.4,{
            opacity : 1,
            y:0+"%"
        })
    }
    out(){
        this.status.open = false
        this.$container.classList.remove("is-open")
        this.$trigger.children[0].classList.remove("is-open")

        TweenMax.to(this.$container,0.4,{
            opacity : 0,
            onComplete:()=>{
                TweenMax.to(this.$bg,0.4,{
                    opacity : 0,
                    y:-110+"%"
                })
            }
        })

    }
}
